import { useMutation } from 'react-query'
import { api } from '../../../api'

const removeResearcher = (id: number) => {
  return api.delete(`/researchers/${id}`)
}

export const useResearcherRemoveMutation = () => {
  return useMutation('remove-researcher', {
    mutationFn: (id: number) => {
      return removeResearcher(id)
    },
  })
}
